export const icons = {
  ai: 'fa-wand-magic-sparkles',
  danger: 'fa-exclamation-triangle',
  info: 'fa-info-circle',
  success: 'fa-check-circle',
  warning: 'fa-exclamation-circle',
  neutral: 'fa-info-circle',
  none: '',
} as const

export type BannerIconType =
  | typeof icons[keyof typeof icons]
  | 'fa-wand-magic-sparkles'
  | 'fa-edit'
  | 'fa-users'

export const levels = {
  page: 'page',
  system: 'system',
} as const

export type bannerLevelType = typeof levels[keyof typeof levels]

export const variants = {
  ai: 'ai',
  danger: 'danger',
  info: 'info',
  success: 'success',
  warning: 'warning',
  neutral: 'neutral',
} as const
